export default function TextInput(props: TextInputProps) {
    const { type, label, value, readonly, disabled, error, ...otherProps } =
        props;

    const inputClassName = `msds-input ${error && 'msds-input--error'} mb-6`;

    const getTodaysDate = () => {
        const today = new Date().toISOString().split('T')[0];
        return today;
    };

    return (
        <div className={inputClassName}>
            <div className="msds-input__icon-wrapper">
                <input
                    type={type ?? 'text'}
                    className="msds-input__text-input"
                    placeholder={label}
                    value={value ?? ''}
                    id={label?.split(' ').join('-')}
                    readOnly={readonly ?? false}
                    disabled={disabled ?? false}
                    min={type === 'date' ? getTodaysDate() : null}
                    {...otherProps}
                />
                {label && (
                    <label
                        className="msds-input__label"
                        htmlFor={label?.split(' ').join('-')}
                    >
                        {label}
                    </label>
                )}
            </div>
            {error &&
                (typeof error === 'string' ? [error] : error).map(
                    (error, index) => (
                        <p key={index} className="msds-input__info-message">
                            {error}
                        </p>
                    )
                )}
        </div>
    );
}

type TextInputProps = {
    type?: 'text' | 'date';
    label?: string;
    value?: string;
    disabled?: boolean;
    readonly?: boolean;
    error?: string | string[];
    [otherProps: string]: unknown;
};
